import makeStyles from '@mui/styles/makeStyles';

const useAddInternalUserStyles = makeStyles({
  root: {}
});

export default useAddInternalUserStyles;
